export default __webpack_public_path__ + "static/media/overlay.5651d171.svg";